import React from 'react';
import { faTimes, faSave, faTimesCircle, faKey } from '@fortawesome/pro-light-svg-icons';
import { FloatingActionButtonBar } from '../../../../components/area-layout/floating-action-button-bar';
import { FloatingActionButton } from '../../../../components/area-layout/floating-action-button';
import { FabDivider } from '../../../../components/area-layout/fab-divider';

interface IRegistrationCounterLaunchboxProps {
  isEditMode: boolean;
  isReadOnly: boolean;
  isSaving: boolean;
  isDeleting: boolean;
  isGeneratingActivationKey: boolean;
  onSave: () => void;
  onValidate: () => boolean;
  onDelete: () => void;
  onGenerateActivationKey: () => void;
}

export function RegistrationCounterLaunchbox(props: IRegistrationCounterLaunchboxProps) {
  const { isEditMode, isReadOnly, isSaving, isDeleting, isGeneratingActivationKey, onSave, onValidate, onDelete, onGenerateActivationKey } = props;

  function handleSave() {
    if (onValidate()) {
      onSave();
    }
  }

  const canEditExisting = isEditMode && !isReadOnly;

  return (
    <FloatingActionButtonBar>
      {canEditExisting && (
        <FloatingActionButton
          loading={isGeneratingActivationKey}
          buttonText={
            <>
              <span>Generér</span>
              <br />
              <span>aktiveringsnøgle</span>
            </>
          }
          icon={faKey}
          onClick={onGenerateActivationKey}
        />
      )}
      {canEditExisting && <FloatingActionButton loading={isDeleting} buttonText="Slet" icon={faTimesCircle} onClick={onDelete} />}
      {canEditExisting && <FabDivider />}
      {!isReadOnly && <FloatingActionButton loading={isSaving} buttonText="Gem og luk" icon={faSave} onClick={handleSave} inverted />}
      <FloatingActionButton buttonText="Luk" icon={faTimes} onClick={() => window.close()} inverted />
    </FloatingActionButtonBar>
  );
}
